import perduPhoto from 'images/perduPhoto.png';
import amenagePhoto from 'images/amenagePhoto.png';
import reglementairePhoto from 'images/reglementairePhoto.png';
import incitatifPhoto from 'images/incitatifPhoto.png';
import accessibilite from 'images/icons/accessibilite.svg';
import illustrationAuditEnergetique from 'images/illustration-audit-energetique.jpg';
import illustrationDiagnosticDPE from 'images/illustration-diagnostic-dpe.jpg';
import hints_text from 'constants/hints_text';

import artisan from 'images/icons/artisan-v2.svg';
import calculatrice from 'images/icons/calculatrice.svg';
import document from 'images/icons/document-v2.svg';
import loupe from 'images/icons/loupe.svg';
import diagnosticAuditEnergetique from 'images/icons/diagnostic/audit-energetique.svg';
import diagnosticDiagnosticDPE from 'images/icons/diagnostic/diagnostic-dpe.svg';
import logoHellioIngenierie from 'images/logo-hellio-ingenierie.svg';

const maison = 'https://hellio.com/hubfs/simulateur/icons3/maison.svg';
const chauffage = 'https://hellio.com/hubfs/simulateur/icons3/chauffage.svg';
const renovation = 'https://hellio.com/hubfs/simulateur/icons3/renovation.svg';
const solaires = 'https://hellio.com/hubfs/simulateur/icons3/solaires.svg';
const recharge = 'https://hellio.com/hubfs/simulateur/icons3/recharge.svg';
// const audit = 'https://hellio.com/hubfs/simulateur/icons3/audit.svg';
const question = 'https://hellio.com/hubfs/simulateur/icons3/question.svg';
const appartement =
  'https://hellio.com/hubfs/simulateur/icons3/appartement.svg';
const tempsA = 'https://hellio.com/hubfs/simulateur/icons3/tempsA.svg';
const tempsB = 'https://hellio.com/hubfs/simulateur/icons3/tempsB.svg';
const tempsC = 'https://hellio.com/hubfs/simulateur/icons3/tempsC.svg';
const isolation1 = 'https://hellio.com/hubfs/simulateur/icons3/isolation1.svg';
const isolation2 = 'https://hellio.com/hubfs/simulateur/icons3/isolation2.svg';
const isolation3 = 'https://hellio.com/hubfs/simulateur/icons3/isolation3.svg';
const isolation4 = 'https://hellio.com/hubfs/simulateur/icons3/isolation4.svg';
const q5a = 'https://hellio.com/hubfs/simulateur/icons3/q5a.svg';
const q5b = 'https://hellio.com/hubfs/simulateur/icons3/q5b.svg';
const mur1 = 'https://hellio.com/hubfs/simulateur/icons3/mur1.svg';
const mur2 = 'https://hellio.com/hubfs/simulateur/icons3/mur2.svg';
const q7a = 'https://hellio.com/hubfs/simulateur/icons3/q7a.svg';
const q7b = 'https://hellio.com/hubfs/simulateur/icons3/q7b.svg';
const q7c = 'https://hellio.com/hubfs/simulateur/icons3/q7c.svg';
const q7d = 'https://hellio.com/hubfs/simulateur/icons3/q7d.svg';
const oui = 'https://hellio.com/hubfs/simulateur/icons3/oui.svg';
const non = 'https://hellio.com/hubfs/simulateur/icons3/non.svg';
const kwA = 'https://hellio.com/hubfs/simulateur/icons3/3kw.svg';
const kwB = 'https://hellio.com/hubfs/simulateur/icons3/7kw.svg';
const kwC = 'https://hellio.com/hubfs/simulateur/icons3/11kw.svg';
const kwD = 'https://hellio.com/hubfs/simulateur/icons3/22kw.svg';
const borneA = 'https://hellio.com/hubfs/simulateur/icons3/borneDIstanceA.svg';
const borneB = 'https://hellio.com/hubfs/simulateur/icons3/borneDIstanceB.svg';
const borneC = 'https://hellio.com/hubfs/simulateur/icons3/borneDIstanceC.svg';
const borneD = 'https://hellio.com/hubfs/simulateur/icons3/borneDIstanceD.svg';
const borneE = 'https://hellio.com/hubfs/simulateur/icons3/borneDIstanceE.svg';
const localPro = 'https://hellio.com/hubfs/simulateur/icons3/localpro.svg';
const localProApt =
  'https://hellio.com/hubfs/simulateur/icons3/localproapt.svg';
const contratA = 'https://hellio.com/hubfs/simulateur/icons3/contratA.svg';
const contratB = 'https://hellio.com/hubfs/simulateur/icons3/contratB.svg';
const autres = 'https://hellio.com/hubfs/simulateur/icons3/autres.svg';
// const copro = 'https://hellio.com/hubfs/simulateur/icons3/copro.svg';
const gaz = 'https://hellio.com/hubfs/simulateur/icons3/gaz.svg';
const fioul = 'https://hellio.com/hubfs/simulateur/icons3/fioul.svg';
const electricite =
  'https://hellio.com/hubfs/simulateur/icons3/electricite.svg';
const pompe = 'https://hellio.com/hubfs/simulateur/icons3/pompe.svg';
const bois = 'https://hellio.com/hubfs/simulateur/icons3/bois.svg';
const charbon = 'https://hellio.com/hubfs/simulateur/icons3/charbon.svg';
const occupant = 'https://hellio.com/hubfs/simulateur/icons3/occupant.svg';
const nonOccupant =
  'https://hellio.com/hubfs/simulateur/icons3/non-occupant.svg';
const bailleur = 'https://hellio.com/hubfs/simulateur/icons3/bailleur.svg';
const locataire = 'https://hellio.com/hubfs/simulateur/icons3/locataire.svg';
const temps1 = 'https://hellio.com/hubfs/simulateur/icons3/temps1.svg';
const temps2 = 'https://hellio.com/hubfs/simulateur/icons3/temps2.svg';
const temps3 = 'https://hellio.com/hubfs/simulateur/icons3/temps3.svg';
const temps4 = 'https://hellio.com/hubfs/simulateur/icons3/temps4.svg';
const adviceB = 'https://hellio.com/hubfs/simulateur/icons3/adviceB.svg';
const adviceC = 'https://hellio.com/hubfs/simulateur/icons3/adviceC.svg';
const newsletterA =
  'https://hellio.com/hubfs/simulateur/icons3/newsletterA.svg';
const newsletterB =
  'https://hellio.com/hubfs/simulateur/icons3/newsletterB.svg';
const auditA = 'https://hellio.com/hubfs/simulateur/icons3/auditA.svg';
const auditB = 'https://hellio.com/hubfs/simulateur/icons3/auditB.svg';
const fenetreA =
  'https://hellio.com/hubfs/simulateur/icons3/FenetreToiture.svg';
const fenetreB = 'https://hellio.com/hubfs/simulateur/icons3/Fenetre.svg';
const gaz1 = 'https://hellio.com/hubfs/simulateur/icons3/gaz.svg';
const gaz2 = 'https://hellio.com/hubfs/simulateur/icons3/gaz2.svg';
const classeA = 'https://hellio.com/hubfs/simulateur/icons3/classeA.svg';
const classeB = 'https://hellio.com/hubfs/simulateur/icons3/classeB.svg';
const classeC = 'https://hellio.com/hubfs/simulateur/icons3/classeC.svg';
const classeD = 'https://hellio.com/hubfs/simulateur/icons3/classeD.svg';
const classeE = 'https://hellio.com/hubfs/simulateur/icons3/classeE.svg';
const classeF = 'https://hellio.com/hubfs/simulateur/icons3/classeF.svg';
const classeG = 'https://hellio.com/hubfs/simulateur/icons3/classeG.svg';
const accompagnateur =
  'https://www.hellio.com/hubfs/simulateur/icons3/accompagnateur.svg';
// const thermostat =
//   'https://www.hellio.com/hubfs/simulateur/icons3/thermostat.svg';
const thermostatSansFil =
  'https://www.hellio.com/hubfs/simulateur/icons3/tags/thermostatSansFil.svg';
const thermostatFilaire =
  'https://www.hellio.com/hubfs/simulateur/icons3/tags/thermostatFilaire.svg';
export const Q1OptionToSkip = ['borneDeRecharge'];

const errors = {
  surface: {
    message: 'Erreur de format : ex. 12345,6 (max. 5 chiffres, 1 décimale)',
  },
};

const dataItems = {
  Q1: {
    greeting: 'Bonjour, quel projet souhaitez-vous réaliser ?',
    // 'paragraph': 'Vous pouvez sélectionner une ou plusieurs réponses.',
    items: [
      {
        short: 'isolation',
        long: 'Isoler mon logement',
        icon: maison,
        urlPrefix: 'isolation',
      },
      {
        short: 'chauffage',
        long: 'Changer mon chauffage',
        icon: chauffage,
        urlPrefix: 'chauffage',
      },
      {
        short: 'renovationGlobale',
        long: 'Rénovation d’ampleur',
        icon: renovation,
        urlPrefix: 'renovation-globale',
      },
      {
        short: 'photovoltaïque',
        long: 'Installer des panneaux solaires',
        icon: solaires,
        urlPrefix: 'panneaux-solaires',
      },
      // Masquer temporairement l'offre "Installation de thermostat" (https://helliosolutions.teamwork.com/app/tasks/27028628)
      // {
      //   short: 'thermostat',
      //   long: 'Installation de Thermostat',
      //   icon: thermostat,
      //   urlPrefix: 'thermostat',
      // },
      {
        short: 'borneDeRecharge',
        long: 'Borne de recharge',
        icon: recharge,
      },
      // {
      //   short: 'auditEnergetique',
      //   long: 'Audit énergétique',
      //   icon: audit,
      //   urlPrefix: 'audit-energetique',
      // },
      {
        short: 'diagnosticLogement',
        long: 'Diagnostiquer mon logement',
        icon: loupe,
      },
      // { short: "primeHellio", long: "J'ai déjà un devis et je veux une prime", icon: adviceB },
      {
        short: 'accompagnateurRenov',
        long: 'Je souhaite avoir un Accompagnateur Rénov’',
        icon: accompagnateur,
        urlPrefix: 'accompagnateur-renov',
      },
      {
        short: 'accessibilite',
        long: "Réaliser des travaux d'accessibilité",
        icon: accessibilite,
        urlPrefix: 'accessibilite',
      },
      {
        short: 'nonRenseigne',
        long: 'J’hésite encore, je souhaite être conseillé',
        icon: question,
        urlPrefix: 'conseil',
      },
    ],
  },

  QAccessibilite: {},

  Q2: {
    greeting: 'Avez-vous une maison ou un appartement ?',
    items: [
      { short: 'Maison individuelle', long: 'Maison', icon: maison },
      { short: 'Appartement', long: 'Appartement', icon: appartement },
    ],
  },

  'Q2.V2': {
    greeting: 'Avez-vous une maison ou un appartement ?',
    items: [
      { short: 'Maison individuelle', long: 'Maison', icon: maison },
      { short: 'Appartement', long: 'Appartement', icon: appartement },
    ],
  },

  Q3: {
    greeting: 'Votre logement a été construit il y a :',
    items: [
      { short: 'Moins de 2 ans', long: 'Moins de 2 ans', icon: tempsA },
      { short: 'Entre 2 et 15 ans', long: 'Entre 2 et 15 ans', icon: tempsB },
      { short: 'Plus de 15 ans', long: 'Plus de 15 ans', icon: tempsC },
    ],
  },
  Q4: {
    greeting: 'Que souhaitez-vous isoler ?',
    paragraph:
      ' Si vous souhaitez isoler votre garage ou sous-sol, ceux-ci ne doivent pas être chauffés.',
    items: [
      {
        short: 'Isolation de combles ou de toitures',
        long: 'Des combles',
        icon: isolation1,
      },
      { short: 'Isolation des murs', long: 'Des murs', icon: isolation2 },
      { short: 'garage', long: 'Un garage ou sous-sol', icon: isolation3 },
      { short: 'vide', long: 'Un vide sanitaire', icon: isolation4 },
    ],
  },
  Q5: {
    greeting: 'Les combles de votre maison sont :',
    minHeight: '350px',
    items: [
      {
        short: 'Perdus',
        long: 'Perdus',
        icon: q5a,
        img: perduPhoto,
        text: "L’isolation se fait au sol - Les combles perdus sont aussi appelés combles non aménageables ou combles visitables. C'est un espace sous la toiture difficile, voire impossible à aménager à cause d’une hauteur libre moyenne insuffisante, ou d’une mauvaise disposition des bois de la charpente.",
      },
      {
        short: 'Aménagés',
        long: 'Aménagés',
        icon: q5b,
        img: amenagePhoto,
        text: 'L’isolation se fait au plafond - Les combles aménagés sont connus sous plusieurs autres appellations comme les combles accessibles ou les combles habitables. Ils désignent des combles qui peuvent être aménagés en lieux de vie, une pièce à part entière de la maison. ',
      },
      // { short: "Non renseigné", long: "Je ne sais pas", icon: question },
    ],
  },

  Q6: {
    greeting: 'Vous souhaitez isoler vos murs :',
    items: [
      { short: 'ITE', long: 'Par l’extérieur', icon: mur1 },
      { short: 'ITI', long: 'Par l’intérieur', icon: mur2 },
    ],
  },

  Q7: {
    greeting:
      'Avez-vous une préférence pour le nouveau chauffage de votre logement ?',
    items: [
      { short: 'Pompe à chaleur', long: 'Pompe à chaleur', icon: q7a },
      { short: 'Chaudière gaz', long: 'Chaudière à gaz', icon: q7b },
      { short: 'Chaudière biomasse', long: 'Chaudière biomasse', icon: q7c },
      { short: 'Poêle à bois', long: 'Poêle à bois', icon: q7d },
      {
        short: 'Non renseigné',
        long: 'Je n’ai pas de préférences',
        icon: question,
      },
    ],
  },
  Q7a: {
    greeting:
      "Prévoyez-vous de remplacer une chaudière individuelle au gaz (autres qu'à condensation), au fioul ou au charbon ?",
    items: [
      { short: 'Oui', long: 'Oui', icon: oui },
      { short: 'Non', long: 'Non', icon: non },
    ],
  },

  Q8: {
    greeting: 'Quelle est la surface de votre logement ?',
    paragraph: 'Veuillez saisir la surface en m²',
    items: [
      {
        label: 'Surface (m²)',
        name: 'Q8',
        placeholder: '150',
        type: 'number',
        min: 10,
        step: 10,
        error: errors.surface.message,
        validation: 'surface',
      },
    ],
  },

  Q9: {
    greeting:
      'Avez-vous déjà votre véhicule électrique ou hybride rechargeable ?',
    items: [
      { short: 'true', long: 'Oui', icon: oui },
      { short: 'false', long: 'Non', icon: non },
    ],
  },

  Q10: {
    greeting: 'Quel est le modèle de votre voiture ?',
    items: [
      { label: 'Modèle', name: 'Q10', placeholder: 'Citroën C4', type: 'text' },
    ],
  },
  Q11: {
    greeting:
      'Connaissez-vous la puissance de recharge dont vous avez besoin ?',
    paragraph: 'kW = Kilowatt',
    items: [
      { short: '3 kW', long: '3 kW', icon: kwA },
      { short: '7 kW', long: '7 kW', icon: kwB },
      { short: '11 kW', long: '11 kW', icon: kwC },
      { short: '22 kW', long: '22 kW', icon: kwD },
      { short: 'Je ne sais pas', long: 'Je ne sais pas', icon: question },
    ],
  },
  Q12: {
    greeting:
      "Quelle est la distance entre votre tableau électrique et l'emplacement souhaité pour votre borne de recharge ?",
    items: [
      {
        short: 'Entre 0 et 10 mètres',
        long: 'Entre 0 et 10 mètres',
        icon: borneA,
      },
      { short: '15 mètres', long: '15 mètres', icon: borneB },
      { short: '20 mètres', long: '20 mètres', icon: borneC },
      { short: '25 mètres', long: '25 mètres', icon: borneD },
      { short: '+ 25 mètres', long: '+ de 25 mètres', icon: borneE },
      { short: 'Je ne sais pas', long: 'Je ne sais pas ', icon: question },
    ],
  },

  Q13: {
    greeting:
      'Dans quel type de local ou logement doit être installer votre borne de recharge ?',
    items: [
      { short: 'Maison individuelle', long: 'Une maison', icon: maison },
      { short: 'Appartement', long: 'Un appartement', icon: appartement },
      {
        short: 'Local professionnel',
        long: 'Un local professionnel',
        icon: localPro,
      },
      {
        short: 'Local professionnel appartement',
        long: 'Un local professionnel en appartement',
        icon: localProApt,
      },
    ],
  },

  Q14: {
    greeting: 'Avez-vous réalisé un audit énergétique pour ce logement ?',
    paragraph:
      "Un audit énergétique permet d'évaluer la performance énergétique actuelle du logement et d'établir les scénarios de rénovation énergétique.",
    items: [
      { short: 'Oui', long: 'Oui', icon: oui },
      { short: 'Non', long: 'Non', icon: non },
    ],
  },

  Q15: {
    greeting:
      'Merci, quel est le montant de votre facture mensuelle d’électricité en euros ? ',
    paragraph:
      'Cela nous permettra de calculer vos économies d’énergie afin de baisser votre facture d’électricité.',
    items: [
      {
        label: 'Montant',
        name: 'Q15',
        placeholder: '89',
        type: 'number',
        unit: '€',
        min: 10,
        step: 10,
      },
    ],
  },

  Q16: {
    greeting: 'Quel est le type de contrat électrique que vous avez ?',
    items: [
      { short: 'Base', long: 'Contrat de base', icon: contratA },
      {
        short: 'Heures pleines heures creuses',
        long: 'Contrat heure creuse / heure pleine',
        icon: contratB,
      },
      { short: 'Autre', long: 'Autres', icon: autres },
    ],
  },

  Q17: {
    greeting: 'Votre projet de rénovation concerne :',
    items: [
      {
        short: 'Logement individuelle',
        long: 'Votre logement individuel',
        icon: maison,
      },
      { short: 'Copropriété', long: 'La copropriété', icon: appartement },
    ],
  },

  Q18: {
    greeting: 'Pouvez-vous remplir les coordonnées de votre syndic :',
    paragraph: 'Tous les champs sont obligatoires.',
    items: [
      {
        label: 'Prénom',
        name: 'syndicFirstname',
        placeholder: 'Pierre',
        type: 'text',
      },
      {
        label: 'Nom',
        name: 'syndicLastname',
        placeholder: 'Roche',
        type: 'text',
      },
      {
        label: 'Téléphone',
        name: 'syndicMobilephone',
        placeholder: '0146821239',
        type: 'tel',
        validation: 'phone',
        maxLength: 10,
        minLength: 10,
      },
      {
        label: 'E-mail',
        name: 'syndicEmail',
        placeholder: 'pierre.roche@gmail.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  Q19: {
    greeting: 'Quels sont les revenus de votre ménage ?',
    greetingSide: true,
    paragraph:
      "Ces informations nous permettront de vous donner la couleur de votre ménage MaPrimeRénov' ",
  },

  Q20: {
    greeting: 'Dans votre logement, vous êtes ?',
    name: 'Q20',
    hint: {
      title: 'Comment répondre ?',
      description: hints_text.Q20,
    },
    items: [
      {
        short: 'Propriétaire',
        long: 'Propriétaire',
        type: 'radio',
        name: 'Q20',
        icon: occupant,
        isCompact: false,
      },
      {
        short: 'Propriétaire occupant',
        long: 'Propriétaire occupant',
        type: 'radio',
        name: 'Q20',
        icon: occupant,
        isCompact: true,
      },
      {
        short: 'Propriétaire non-occupant',
        long: 'Propriétaire non-occupant',
        type: 'radio',
        name: 'Q20',
        icon: nonOccupant,
        isCompact: true,
      },
      {
        short: 'Propriétaire bailleur',
        long: 'Propriétaire bailleur',
        type: 'radio',
        name: 'Q20',
        icon: bailleur,
        tooltip: true,
        isCompact: true,
      },
      {
        short: 'Locataire',
        long: 'Locataire',
        type: 'radio',
        name: 'Q20',
        icon: locataire,
      },
    ],
  },

  Q21: {
    greeting:
      'En tant que propriétaire bailleur, quelle est l’adresse de votre résidence principale ?',
    paragraph:
      'Les aides à la rénovation énergétique varient en fonction de votre localisation.',
    items: [
      { label: 'Adresse', name: 'street', placeholder: '113 rue du soiemont' },
      {
        label: 'Ville',
        name: 'city',
        placeholder: 'Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson',
      },
      {
        label: 'Code postal',
        name: 'postalcode',
        placeholder: '51290',
        validation: 'codepostal',
        maxLength: 5,
        minLength: 5,
      },
    ],
  },

  Q22: {
    greeting: 'Quelle est l’énergie de chauffage actuelle de votre logement ?',
    items: [
      { short: 'Gaz', long: 'Gaz', icon: gaz },
      { short: 'Fioul', long: 'Fioul', icon: fioul },
      { short: 'Electricité', long: 'Électricité', icon: electricite },
      { short: 'Pompe à chaleur', long: 'Pompe à chaleur', icon: pompe },
      { short: 'Bois', long: 'Bois', icon: bois },
      // { short: "Solaire thermique", long: "Solaire thermique", icon: panneaux },
      { short: 'Charbon', long: 'Charbon', icon: charbon },
      // { short: "Je ne suis pas chauffé(e)", long: "Je ne suis pas chauffé(e)", icon: non },
    ],
  },

  Q26: {
    greeting: "Merci, quelle est l'adresse du logement à rénover ?",
    paragraph:
      'L’adresse de votre logement est nécessaire pour calculer les aides que vous pourrez obtenir et estimer votre étiquette énergétique.',
    items: [
      { label: 'Adresse', name: 'street', placeholder: '113 rue du soiemont' },
      {
        label: 'Ville',
        name: 'city',
        placeholder: 'Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson',
      },
      {
        label: 'Code postal',
        name: 'postalcode',
        placeholder: '51290',
        validation: 'codepostal',
        maxLength: 5,
        minLength: 5,
      },
    ],
  },

  Q27: {
    greeting: 'Quelle est votre adresse fiscale ?',
    paragraph: 'Tous les champs sont obligatoires.',
    items: [
      { label: 'Adresse', name: 'street', placeholder: '113 rue du soiemont' },
      {
        label: 'Ville',
        name: 'city',
        placeholder: 'Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson',
      },
      {
        label: 'Code postal',
        name: 'postalcode',
        placeholder: '51290',
        validation: 'codepostal',
        maxLength: 5,
        minLength: 5,
      },
    ],
  },

  Q28: {
    greeting:
      'Parfait ! Sous combien de temps souhaitez-vous réaliser ces travaux ?',
    items: [
      { short: 'Dès que possible', long: 'Dès que possible', icon: temps1 },
      { short: 'Moins de 3 mois', long: 'Moins de 3 mois', icon: temps2 },
      { short: 'Moins de 6 mois', long: 'Moins de 6 mois', icon: temps3 },
      { short: 'Plus de 6 mois', long: 'Plus de 6 mois', icon: temps4 },
    ],
  },

  Q29: {
    greeting:
      'Merci, maintenant apprenons à nous connaître. <br/> Pouvez-vous remplir vos coordonnées :',
    paragraph: '',
    optional: true,
    policy: true,
    items: [
      {
        label: 'Prénom',
        name: 'firstname',
        placeholder: 'Pierre',
        type: 'text',
      },
      { label: 'Nom', name: 'lastname', placeholder: 'Roche', type: 'text' },
      {
        label: 'Téléphone',
        name: 'mobilephone',
        placeholder: '0146821239',
        type: 'tel',
        validation: 'phone',
        maxLength: 10,
        minLength: 10,
      },
      {
        label: 'E-mail',
        name: 'email',
        placeholder: 'pierre.roche@gmail.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  Q30: {
    greeting: 'Comment souhaitez-vous être accompagné ?',
    items: [
      // { short: "comparaisonDevis", long: "Je veux comparer mon devis", icon: adviceA },
      {
        short: 'primeHellio',
        long: 'Je veux faire des travaux et bénéficier de la prime Hellio',
        icon: adviceB,
      },
      {
        short: 'simulationTravaux',
        long: 'Je veux simuler le coût de mes travaux et ma prime',
        icon: adviceC,
      },
    ],
  },

  Q31: {
    greeting: 'Avez-vous un code partenaire ou parrain ?',
    items: [
      { short: 'true', long: 'Oui', icon: oui },
      { short: 'false', long: 'Non', icon: non },
    ],
  },

  Q32: {
    greeting: 'Remplissez votre code partenaire ou parrain :',
    items: [{ label: 'Code', name: 'Q32', placeholder: 'BDICC3000' }],
  },

  Q33: {
    greeting: 'Souhaitez-vous recevoir la newsletter Hellio ?',
    paragraph:
      "Restez informé(e) sur les économies d'énergies et les aides à la rénovation.",
    items: [
      {
        short: 'Oui, 1 fois par mois',
        long: 'Oui, 1 fois par mois',
        icon: newsletterA,
      },
      {
        short: 'Oui, 1 fois par trimestre',
        long: 'Oui, 1 fois par trimestre',
        icon: newsletterB,
      },
      {
        short: 'Je ne suis pas intéressé(e)',
        long: 'Je ne suis pas intéressé',
        icon: non,
      },
    ],
  },

  Q36: {
    greeting: 'Qu’est ce qu’une rénovation d’ampleur ?',
    content: `Recommandée pour les logements à fortes consommations énergétiques et émissions de gaz à effet de serre, la rénovation d’ampleur combine plusieurs travaux pour améliorer le confort toute l'année et réaliser des économies d'énergie.<br/>Tout au long de votre projet, vous serez suivi par Mon Accompagnateur Rénov', un interlocuteur de confiance obligatoire pour vos travaux proposé par Hellio Ingénierie, qui vous offre :`,
    list: [
      'Conseil technique : travaux, audit énergétique, etc.',
      'Appui financier : plan de financement, compréhension des devis, etc.',
      'Aide administrative et sociale : identification des besoins, assistance dans les démarches administratives, etc.',
    ],
  },

  Q37: {
    greeting: 'Pourquoi faire réaliser un audit énergétique ?',
    content:
      'Ce bilan permet de déterminer les travaux de rénovation d’ampleur les plus efficaces, avec la garantie d’atteindre un certain niveau de performance énergétique.',
    list: [
      'Le professionnel calcule les économies d’énergie réelles et les caractéristiques thermiques du logement',
      'Primes disponibles sans condition de ressources : un atout pour les ménages aux revenus intermédiaires ou supérieurs',
      'Ouvre droit à un maximum d’aides financières pour rénover : l’investissement est facilement rentabilisé',
    ],
  },

  Q38: {
    greeting: '',
    title: 'Votre inscription a bien été pris en compte.',
    paragraph:
      'Un expert Hellio vous rappelera dans les plus brefs délais pour donner suite à votre projet.',
  },

  Q39: {
    greeting: 'Que souhaitez-vous isoler ?',
    paragraph:
      ' Si vous souhaitez isoler votre garage ou sous-sol, celui-ci ne doit pas être chauffé.',
    items: [
      {
        short: 'combles',
        long: 'Des combles',
        icon: isolation1,
      },
      { short: 'murs', long: 'Des murs', icon: isolation2 },
      { short: 'garage', long: 'Un garage ou sous-sol', icon: isolation3 },
      { short: 'vide', long: 'Un vide sanitaire', icon: isolation4 },
    ],
  },

  Q40: {
    greeting:
      'Avez-vous une préférence pour le nouveau chauffage de votre logement ?',
    items: [
      { short: 'Pompe à chaleur air/eau', long: 'Pompe à chaleur', icon: q7a },
      { short: 'Chaudière gaz', long: 'Chaudière à gaz', icon: q7b },
      {
        short: 'Chaudière biomasse',
        long: 'Chaudière à granulés de bois',
        icon: q7c,
      },
      { short: 'Poêle à bois', long: 'Poêle à bois', icon: q7d },
      {
        short: 'Non renseigné',
        long: 'Je n’ai pas de préférences',
        icon: question,
      },
    ],
  },

  Q43: {
    greeting: 'Où en êtes-vous dans votre projet ?',
    items: [
      {
        short: 'Je cherche un artisan RGE',
        long: 'Je cherche un artisan RGE',
        icon: artisan,
      },
      {
        short: 'Je veux comparer mon devis',
        long: 'Je veux comparer mon devis',
        icon: calculatrice,
      },
      {
        short: "J'ai reçu des devis et les ai signés",
        long: 'J’ai déjà signé mon devis',
        icon: document,
      },
    ],
  },

  Q44: {
    greeting: 'Quel est la surface à isoler ?',
    paragraph:
      'Le coût et les aides de vos travaux sont calculés à partir de la surface à isoler et non la surface habitable. Veuillez saisir la surface en m²',
    items: [
      {
        label: 'Surface (m²)',
        name: 'Q44',
        placeholder: '150',
        type: 'number',
        min: 10,
        step: 10,
        error: errors.surface.message,
        validation: 'surface',
      },
    ],
  },

  Q45: {
    greeting: 'Vous avez un devis pour quel type de travaux ?',
    items: [
      [
        { short: 'Isolation des combles', long: 'Des combles' },
        { short: 'Isolation des murs', long: 'Des murs' },
        { short: 'Fenêtre', long: 'Des fenêtres' },
        {
          short: "Isolation d'un plancher",
          long: 'Un vide sanitaire, plancher bas ou sous sol',
        },
      ],
      [
        { short: 'PAC eau/eau', long: 'Pompe à chaleur eau/eau' },
        { short: 'Poêle à bois', long: 'Poêle à bois' },
        { short: 'PAC air/eau', long: 'Pompe à chaleur air/eau' },
        {
          short: 'Réseau de chaleur',
          long: 'Raccordement à un réseau de chaleur',
        },
        {
          short: 'PAC hybride air/eau',
          long: 'Pompe à chaleur hybride air/eau',
        },
        {
          short: 'Chaudière à granulé de bois',
          long: 'Chaudière biomasse (bois)',
        },
        { short: 'Poêle à granulé de bois', long: 'Poêle à granulé de bois' },
        { short: 'Système solaire combiné', long: 'Système solaire combiné' },
        { short: 'Chaudière gaz', long: 'Chaudière à gaz' },
      ],
      [
        {
          short: 'Chauffe-eau thermodynamique',
          long: 'Chauffe-eau thermodynamique',
        },
        {
          short: 'Chauffe-eau solaire individuel',
          long: 'Chauffe-eau solaire individuel (ECS)',
        },
      ],
      [
        { short: 'VMC simple flux', long: 'VMC Simple flux' },
        { short: 'VMC double flux', long: 'VMC double flux' },
      ],
      [{ short: 'Autre', long: 'Autre travaux' }],
    ],
  },

  Q46: {
    greeting: 'Combien de fenêtres souhaitez-vous installer ?',
    items: [
      {
        label: '',
        name: 'Q46',
        placeholder: '3',
        type: 'number',
        min: 1,
        step: 1,
      },
    ],
  },

  Q47: {
    greeting: 'Quelle est la surface chauffée ?',
    paragraph: 'Veuillez saisir la surface en m²',
    items: [
      {
        label: 'Surface (m²)',
        name: 'Q47',
        placeholder: '150',
        type: 'number',
        min: 5,
        step: 10,
        error: errors.surface.message,
        validation: 'surface',
      },
    ],
  },

  Q48: {
    greeting: 'Pourquoi souhaitez-vous réaliser un audit énergétique ?',
    items: [
      {
        short: 'Audit énergétique',
        long: 'Audit incitatif',
        icon: auditA,
        img: incitatifPhoto,
        text: 'Je souhaite un audit énergétique pour réaliser des travaux de rénovation énergétique et obtenir des aides',
      },
      {
        short: 'Audit règlementaire',
        long: 'Audit réglementaire',
        icon: auditB,
        img: reglementairePhoto,
        text: 'Je dois réaliser un audit énergétique pour vendre mon bien classé F ou G au DPE',
      },
    ],
  },
  Q49: {
    greeting: 'Quel type de fenêtre souhaiteriez-vous installer ?',
    items: [
      {
        short: 'Portes-fenêtres',
        long: 'Fenêtres ou Portes-fenêtres complètes avec vitrage isolant',
        icon: fenetreB,
      },
      { short: 'Fenêtres', long: 'Fenêtres de toitures', icon: fenetreA },
    ],
  },

  Q50: {
    greeting: 'Quel type de pompe à chaleur souhaitez-vous installer ? ',
    items: [
      {
        short: 'Pompe à chaleur air/air',
        long: 'Pompe à chaleur air/air',
        icon: gaz1,
      },
      {
        short: 'Pompe à chaleur air/eau',
        long: 'Pompe à chaleur air/eau',
        icon: gaz2,
      },
      {
        short: 'Pompe à chaleur eau/eau',
        long: 'Pompe à chaleur eau/eau',
        icon: gaz2,
      },
      { short: 'Non renseigné', long: 'Je ne sais pas', icon: question },
    ],
  },

  Q51: {
    greeting: "Quel est l'usage de votre pompe à chaleur ?",
    items: [
      { short: 'Chauffage seul', long: 'Chauffage uniquement', icon: gaz1 },
      {
        short: 'Chauffage + Eau Chaude Sanitaire',
        long: 'Chauffage et eau chaude sanitaire',
        icon: gaz2,
      },
      {
        short: 'Je ne sais pas',
        long: 'Je ne sais pas et je souhaite être conseillé',
        icon: question,
      },
    ],
  },

  Q53: {
    greeting: "Quelle est l'étiquette énergétique de votre logement ?",
    paragraph:
      'L’étiquette énergétique (Diagnostic de performance énergétique ou DPE) permet d’évaluer la consommation énergétique de votre logement',
    items: [
      { short: 'A', long: '', icon: classeA },
      { short: 'B', long: '', icon: classeB },
      { short: 'C', long: '', icon: classeC },
      { short: 'D', long: '', icon: classeD },
      { short: 'E', long: '', icon: classeE },
      { short: 'F', long: '', icon: classeF },
      { short: 'G', long: '', icon: classeG },
      {
        short: 'Je ne sais pas',
        long: "Je ne connais pas l'étiquette énergétique de mon logement",
      },
    ],
  },

  'Q4.V2': {
    text: "Vous avez un projet de rénovation d'ampleur et vous souhaitez obtenir de l'aide grâce au programme Mon Accompagnateur Rénov'.</br><a href='https://ingenierie.hellio.com/' target='_blank'>Inscrivez-vous sur Hellio Ingénierie.</a>",
    redirect: 'https://ingenierie.hellio.com/formulaire',
    image:
      'https://www.hellio.com/hubfs/simulateur/images/Hellio-ingenierie_LogoBaseline_RVB_Couleurs1.png',
  },

  'Q53.V2': {
    greeting: 'Quel type de chauffage utilisez-vous ?',
    items: [
      { short: 'Individuel', long: 'Individuel', icon: nonOccupant },
      { short: 'Collectif', long: 'Collectif', icon: appartement },
    ],
  },

  Q54: {
    greeting: 'Avez-vous des robinets thermostatiques en place ?',
    items: [
      { short: 'Oui', long: 'Oui', icon: oui },
      { short: 'Non', long: 'Non', icon: non },
    ],
  },
  Q55: {
    greeting: 'Avez-vous un thermostat existant ?',
    items: [
      {
        short: 'Oui, en filaire',
        long: 'Oui, en filaire',
        icon: thermostatFilaire,
      },
      {
        short: 'Oui, sans fil',
        long: 'Oui, sans fil',
        icon: thermostatSansFil,
      },
      { short: 'Non', long: 'Non', icon: non },
    ],
  },
  Q56: {
    greeting:
      'Quelle est le nombre d’émetteurs de chaleur dans votre logement ?',
    labelNoWrap: true,
    items: [
      {
        label: 'Nombre d’émetteurs',
        name: 'Q56',
        placeholder: '15',
        type: 'number',
      },
    ],
  },
  Q57: {
    name: 'Q57',
    greeting: 'Allez-vous vivre dans le logement à rénover ?',
    subtitle: '(propriétaire occupant)',
    hint: {
      title: 'Comment répondre ?',
      description: hints_text.Q57,
    },
    items: [
      {
        short: 'Oui',
        long: 'Oui',
        type: 'radio',
        name: 'Q57',
      },
      {
        short: 'Non',
        type: 'radio',
        long: 'Non',
        name: 'Q57',
      },
    ],
  },
  Q58: {
    name: 'Q58',
    greeting: 'Le logement sera-t-il la résidence principale du locataire ?',
    hint: {
      title: 'Comment répondre ?',
      description: hints_text.Q58,
    },
    items: [
      {
        short: 'Oui',
        long: 'Oui',
        type: 'radio',
        name: 'Q58',
      },
      {
        short: 'Non',
        long: 'Non',
        type: 'radio',
        name: 'Q58',
      },
    ],
  },
  OptimhomeAgent: {
    greeting: 'Quelle est votre adresse e-mail Optimhome ?',
    paragraph: 'Exemple : jean.dubois@optimhome.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@optimhome.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  ToutvabiensParticulier: {
    greeting: 'Quelle est votre adresse e-mail ?',
    paragraph: 'Exemple : jean.dubois@toutvabiens.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@toutvabiens.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  ToutvabiensAgent: {
    greeting: 'Quelle est votre adresse e-mail ?',
    paragraph: 'Exemple : jean.dubois@toutvabiens.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@toutvabiens.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  OptimhomeClient: {
    greeting: "Indiquez l'adresse e-mail de votre conseiller Optimhome",
    paragraph: 'Exemple : jean.dubois@optimhome.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@optimhome.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  CapifranceAgent: {
    greeting: 'Quelle est votre adresse e-mail Capifrance ?',
    paragraph: 'Exemple : jean.dubois@capifrance.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@capifrance.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  CapifranceClient: {
    greeting: 'Indiquez l’adresse e-mail de votre conseiller Capifrance ?',
    paragraph: 'Exemple : jean.dubois@capifrance.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@capifrance.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  LaforetAgent: {
    greeting: 'Quelle est votre agence Laforêt ?',
    paragraph:
      'Pour faciliter votre recherche, veuillez saisir votre code agence(exemple: A84)',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@laforet.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  LotsAgent: {
    greeting: 'Quelle est votre adresse e-mail ?',
    paragraph: 'Exemple : jean.dubois@gmail.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@capifrance.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  LaforetClient: {
    greeting: 'Dans quelle agence Laforêt êtes-vous client ?',
    paragraph:
      'Pour faciliter votre recherche, veuillez saisir votre code agence (exemple: A84)',
    // 'items': [
    //     { label: 'E-mail', name: "partenaireEmail", placeholder: 'jean.dubois@capifrance.com', type:'email', validation: 'email'},
    // ],
  },
  LaforetAgentEmailPhone: {
    greeting: 'Quelle est votre agence Laforêt ?',
    paragraph:
      'Pour faciliter votre recherche, veuillez saisir votre code agence(exemple: A84)',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@laforet.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  LaforetEmailPhone: {
    greeting: 'Quelle est votre adresse e-mail Laforêt ?',
    paragraph: 'Exemple : jean.dubois@laforet.com',
    email: {
      label: 'E-mail',
      name: 'partenaireEmail',
      placeholder: 'jean.dubois@laforet.com',
      type: 'email',
      validation: 'email',
    },
    phone: {
      label: 'Téléphone',
      name: 'partenairePhone',
      placeholder: '0146821239',
      type: 'tel',
      validation: 'phone',
      maxLength: 10,
      minLength: 10,
    },
  },
  LotsADB: {
    greeting: 'Quelle est votre adresse e-mail ?',
    paragraph: 'Exemple : jean.dubois@gmail.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@laforet.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },
  BricomarcheEmail: {
    greeting: 'Quelle est votre adresse e-mail ?',
    paragraph: 'Exemple : jean.dubois@bricomarche.com',
    items: [
      {
        label: 'E-mail',
        name: 'partenaireEmail',
        placeholder: 'jean.dubois@bricomarche.com',
        type: 'email',
        validation: 'email',
      },
    ],
  },

  QTypeDiagnostic: {
    greeting: 'Quel diagnostic souhaitez-vous réaliser ?',
    items: [
      {
        short: 'audit_energetique',
        long: 'Un Audit énergétique',
        icon: diagnosticAuditEnergetique,
        image: illustrationAuditEnergetique,
        paragraph:
          '<strong>Choisir l’audit énergétique&nbsp;:</strong> pour un projet de rénovation sérieuse ou pour vendre un logement F/G (obligatoire).',
        list: [
          'Analyse détaillée du logement',
          'Plan de travaux précis et hiérarchisé',
          'Indispensable pour lancer un projet de rénovation',
        ],
      },
      {
        short: 'dpe',
        long: 'Un Diagnostic de Performance Énergétique (DPE)',
        icon: diagnosticDiagnosticDPE,
        image: illustrationDiagnosticDPE,
        paragraph:
          '<strong>Choisir le DPE&nbsp;:</strong> pour une transaction immobilière classique ou une information rapide sur la performance énergétique.',
        list: [
          'Étiquette énergie & climat',
          'Rapide et moins coûteux que l’audit',
          'Obligatoire pour toute vente ou location',
        ],
      },
    ],
  },

  QDiagnosticAuditEnergetique: {
    greeting: 'Que souhaitez-vous faire ?',
    items: [
      {
        short: 'conseil',
        long: 'Je souhaite être conseillé',
        type: 'radio',
      },
      {
        short: 'audit_energetique',
        long: 'Je souhaite commander un audit énergétique',
        type: 'radio',
      },
    ],
  },

  QDiagnosticAuditEnergetiqueRedirect: {
    text: 'Vous allez être redirigé vers Hellio Ingénierie',
    subText:
      '<strong>Hellio Ingénierie</strong>, bureau d’études spécialisé dans la performance énergétique et filiale du groupe Hellio, <strong>vous accompagne dans la réalisation de votre Audit énergétique</strong>.',
    redirect: 'https://ingenierie.hellio.com/solutions/audit#commandez-audit',
    image: logoHellioIngenierie,
  },

  QDiagnosticDPERedirect: {
    text: 'Vous allez être redirigé vers Hellio Ingénierie',
    subText:
      '<strong>Hellio Ingénierie</strong>, bureau d’études spécialisé dans la performance énergétique et filiale du groupe Hellio, <strong>vous accompagne dans la réalisation de votre DPE</strong>.',
    redirect: 'https://ingenierie.hellio.com/solutions/dpe#commandez-dpe',
    image: logoHellioIngenierie,
  },

  QDiagnosticDPE: {
    greeting: 'Que souhaitez-vous faire ?',
    items: [
      {
        short: 'conseil',
        long: 'Je souhaite être conseillé',
        type: 'radio',
      },
      {
        short: 'dpe',
        long: 'Je souhaite commander un Diagnostic de Performance Énergétique',
        type: 'radio',
      },
    ],
  },

  Success: {
    greeting: 'Success',
  },

  CreneauPicker: {
    creneau: [
      { label: 'Creneau', name: 'Creneau', value: 'Matin' },
      { label: 'Creneau', name: 'Creneau', value: 'Après-midi' },
    ],
  },
};

export default dataItems;
